module.exports = global["NeatComplete"] = require("-!/home/circleci/repo/node_modules/babel-loader/lib/index.js??ref--5!./neat_complete.min.js");